const VENUE_PLANS = [
    {
        name: 'Basic',
        internalName: 'VenueFree',
        descriptor: 'Features:',
        color: '#cdeb09',
        price: {
            month: 0,
            year: 0
        },
        features: [
            {
                name: 'Booking Manager Lite',
                subfeatures: [
                    {
                        name: 'Manage up to 5 Shows at the Same Time',
                        desc: 'Manage your shows from start to finish.'
                    },
                    {
                        name: 'Events Calendar',
                        desc: 'See what needs to get done with your personalized at-a-glance calendar.'
                    },
                    {
                        name: 'Check Avails',
                        desc: 'Share unique event links with your current roster, exclusive hedlyner talent, or new artists off the street.'
                    },
                    {
                        name: 'Centralized Inbox',
                        desc: 'No more checking texts, emails, DMs, and voicemails. Get a smarter inbox. Make offers. Accept counteroffers.'
                    },
                    {
                        name: '5% In-App Booking Fee',
                        desc: 'The transaction fee is calculated based on the booking rate and added to the total amount debited from your account. For example, the total amount debited from your account for $100 booking rate is $105.'
                    },
                    {
                        name: 'Pay with Credit Cards',
                        desc: 'Pay artists quickly through a trusted platform. Funds are released after the show.'
                    },
                    {
                        name: 'Event Wrap-up',
                        desc: 'Track payment management with the post-show payout summary.'
                    },
                    {
                        name: 'Reviews and Ratings',
                        desc: 'Share feedback with your community. Learn from your peers.'
                    }
                ]
            },
            {
                name: 'Artist Management',
                subfeatures: [
                    {
                        name: 'Discover Artists',
                        desc: "Search for public artist profiles and quickly see who's a good match. Listen to their music and see their reach all in one convenient place."
                    },
                    {
                        name: 'Artists Network',
                        desc: 'Keep track of booked artists and new talent in one centralized place.'
                    }
                ]
            },
            {
                name: 'Account Management',
                subfeatures: [
                    {
                        name: 'One Venue',
                        desc: 'Showcase your venue with Venue Profiles.'
                    },
                    {
                        name: 'One User Account',
                        desc: 'One login to manage all your events.'
                    }
                ]
            }
        ]
    },
    {
        name: 'Pro',
        internalName: 'VenuePro',
        descriptor: 'Everything in Basic, plus...',
        color: '#d8b500',
        price: {
            month: 45,
            year: 39
        },
        features: [
            {
                name: 'Booking Manager Pro',
                subfeatures: [
                    {
                        name: 'Manage up to 10 Shows at the Same Time',
                        desc: 'Manage your shows from start to finish.'
                    },
                    {
                        name: '0% In-App Venue Booking Fee',
                        desc: 'Save 5% on transaction fees. The transaction fee is caluclated based on the booking rate and added to the total amount debited from your account. For example, the total amount debited from your account for a $100 booking rate is $103.'
                    },
                    {
                        name: 'Event Promotion Tools',
                        desc: 'Share beautifully created event pages with just a click of a button.'
                    }
                ]
            }
        ]
    },
    {
        name: 'Growth',
        internalName: 'VenueGrowth',
        descriptor: 'Everything in Pro, plus...',
        color: '#e0939c',
        price: {
            month: 75,
            year: 64
        },
        features: [
            {
                name: null,
                subfeatures: [
                    {
                        name: 'Manage up to 20 Shows at the Same Time',
                        desc: 'Manage your shows from start to finish.'
                    }
                ]
            }
        ]
    },
    {
        name: 'Premium',
        internalName: 'VenuePremium',
        descriptor: 'Everything in Growth, plus...',
        color: '#ba87ff',
        price: {
            month: 115,
            year: 98
        },
        features: [
            {
                name: null,
                subfeatures: [
                    {
                        name: 'Unlimited Shows',
                        desc: 'Manage your shows from start to finish.'
                    }
                ]
            }
        ]
    }
]
const VENUE_PLAN_NAMES = VENUE_PLANS.map((plan) => ({ name: plan.name, internalName: plan.internalName }))

const ARTIST_PLANS = []

const ARTIST_PLAN_NAMES = VENUE_PLANS.map((plan) => plan.name)

export { VENUE_PLANS, VENUE_PLAN_NAMES, ARTIST_PLANS, ARTIST_PLAN_NAMES }
